import { render, staticRenderFns } from "./VET_Values.vue?vue&type=template&id=0383021f&scoped=true"
import script from "./VET_Values.vue?vue&type=script&lang=js"
export * from "./VET_Values.vue?vue&type=script&lang=js"
import style0 from "./VET_Values.vue?vue&type=style&index=0&id=0383021f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0383021f",
  null
  
)

export default component.exports